import { SECTION } from '@/components/layout/types';
import { contractVersicherungsangabenSectionConfig } from '@/features/Sparten/shared/provident/contractVersicherungsangabenSectionConfig';
import {
  VersicherungsangabenConfig,
  VersicherungsangabenSectionConfig,
} from '@/features/Versicherungsangaben/types';

const inputConfig: VersicherungsangabenSectionConfig = {
  [SECTION.INPUT_VP]: {
    label: 'Angaben zur versicherten Person',
    component: () =>
      import(
        '@/features/Sparten/shared/sections/provident/input/InputVersichertePerson.vue'
      ),
  },
  [SECTION.INPUT_VN]: {
    label: 'Angaben zum Versicherungsnehmer',
    component: () =>
      import(
        '@/features/Sparten/shared/sections/provident/input/InputVersicherungsnehmer.vue'
      ),
  },
  [SECTION.INPUT_ABSICHERUNG]: {
    label: 'Gewünschte Absicherung',
    component: () =>
      import('@/features/Sparten/bu/sections/input/InputAbsicherung.vue'),
  },
  [SECTION.INPUT_BEITRAGSREDUZIERUNG]: {
    label: 'Mögliche Beitragsreduzierung',
    component: () =>
      import(
        '@/features/Sparten/bu/sections/input/InputBeitragsReduzierung.vue'
      ),
  },
};

export const buVersicherungsangabenConfig: VersicherungsangabenConfig = {
  inputConfig,
  contractConfig: contractVersicherungsangabenSectionConfig,
  requiresCompanies: true,
};
